import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { automationsClient } from '#pplx_generated/typespec/rest/automations/client.js';
export const runAutomationNow = async ({ automationId, }) => {
    const { error, response } = await automationsClient.POST('/rest/automations/{automation_id}/run', 'run-automation-now', {
        params: {
            path: {
                automation_id: automationId,
            },
        },
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to run automation now',
            cause: error,
            status: response.status ?? 0,
        });
    }
};
//# sourceMappingURL=runAutomationNow.js.map